import { Button, ButtonsGroup, Flex } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface AccountFromTemplateModalActionsProps {
  isResetDisabled?: boolean
  isSaveButtonDisabled?: boolean
  onClose: () => void
  onReset?: () => void
  onSubmit: () => void
  saveLabel: string
}

export const AccountFromTemplateModalActions = ({
  isResetDisabled,
  isSaveButtonDisabled,
  onClose,
  onReset,
  onSubmit,
  saveLabel,
}: AccountFromTemplateModalActionsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex alignItems="center" justifyContent={onReset ? 'space-between' : 'flex-end'} width="100%">
      {onReset && (
        <Button disabled={isResetDisabled} onClick={onReset} variant="text">
          {t('coa.account_from_base_form.reset')}
        </Button>
      )}
      <ButtonsGroup>
        <Button onClick={onClose} variant="tonal">
          {t('cancel')}
        </Button>
        <Button disabled={isSaveButtonDisabled} onClick={onSubmit}>
          {saveLabel}
        </Button>
      </ButtonsGroup>
    </Flex>
  )
}
